{
  "CANNED_MGMT": {
    "HEADER": "Unaprijed pripremljeni odgovori",
    "LEARN_MORE": "Saznajte više o unaprijed pripremljenim odgovorima",
    "DESCRIPTION": "Unaprijed pripremljeni odgovori su već napisani predlošci za odgovore koji vam pomažu da brzo odgovorite na razgovor. Agenti mogu upisati znak '/' nakon kojeg slijedi kratki kod za umetanje unaprijed pripremljenog odgovora tijekom razgovora.",
    "HEADER_BTN_TXT": "Dodaj unaprijed pripremljeni odgovor",
    "LOADING": "Dohvaćanje unaprijed pripremljenih odgovora...",
    "SEARCH_404": "Ne postoji rezultat za zadano pretraživanje.",
    "LIST": {
      "404": "Na ovom računu nema unaprijed pripremljenih odgovora.",
      "TITLE": "Upravljajte unaprijed pripremljenim odgovorima",
      "DESC": "Unaprijed pripremljeni odgovori su predlošci odgovora s pomoću kojih možete brzo odgovarati u razgovorima.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Kratki kod",
        "CONTENT": "Sadržaj",
        "INBOXES": "Sandučići",
        "ACTIONS": "Radnje"
      },
      "ALL_INBOXES": "Svi sandučići",
      "FILTER": {
        "ALL_INBOXES": "Svi sandučići",
        "NO_INBOX": "Bez sandučića",
        "SEARCH_PLACEHOLDER": "Pretraži sandučiće"
      }
    },
    "ADD": {
      "TITLE": "Dodaj unaprijed pripremljeni odgovor",
      "DESC": "Unaprijed pripremljeni odgovori su predlošci odgovora s pomoću kojih možete brzo odgovarati u razgovorima.",
      "CANCEL_BUTTON_TEXT": "Odustani",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Kratki kod",
          "PLACEHOLDER": "Unesite kratki kod.",
          "ERROR": "Kratki kod je obavezan."
        },
        "SUBJECT": {
          "LABEL": "Predmet (samo e-pošta)",
          "PLACEHOLDER": "Neobavezni predmet za e-mail odgovore / nove razgovore"
        },
        "CONTENT": {
          "LABEL": "Poruka",
          "PLACEHOLDER": "Napišite poruku koju želite spremiti kao predložak za kasniju upotrebu.",
          "ERROR": "Poruka je obavezna."
        },
        "ATTACHMENTS": {
          "LABEL": "Privici"
        },
        "INBOXES": {
          "LABEL": "Sandučići",
          "PLACEHOLDER": "Odaberite sandučiće (opcionalno, ostavite prazno za sve sandučiće)"
        },
        "SUBMIT": "Pošalji"
      },
      "API": {
        "SUCCESS_MESSAGE": "Unaprijed pripremljeni odgovor uspješno je dodan.",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "EDIT": {
      "TITLE": "Uredi unaprijed pripremljeni odgovor",
      "CANCEL_BUTTON_TEXT": "Odustani",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Kratki kod",
          "PLACEHOLDER": "Unesite kratki kod.",
          "ERROR": "Kratki kod je obavezan."
        },
        "SUBJECT": {
          "LABEL": "Predmet (samo e-pošta)",
          "PLACEHOLDER": "Neobavezni predmet za e-mail odgovore / nove razgovore"
        },
        "CONTENT": {
          "LABEL": "Poruka",
          "PLACEHOLDER": "Napišite poruku koju želite spremiti kao predložak za kasniju upotrebu.",
          "ERROR": "Poruka je obavezna."
        },
        "ATTACHMENTS": {
          "LABEL": "Privici"
        },
        "INBOXES": {
          "LABEL": "Sandučići",
          "PLACEHOLDER": "Odaberite sandučiće (opcionalno, ostavite prazno za sve sandučiće)"
        },
        "SUBMIT": "Pošalji"
      },
      "BUTTON_TEXT": "Uredi",
      "API": {
        "SUCCESS_MESSAGE": "Unaprijed pripremljeni odgovor uspješno je ažuriran.",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "API": {
        "SUCCESS_MESSAGE": "Unaprijed pripremljeni odgovor uspješno je izbrisan.",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      },
      "CONFIRM": {
        "TITLE": "Potvrdi brisanje",
        "MESSAGE": "Jeste li sigurni da želite izbrisati ",
        "YES": "Da, izbriši ",
        "NO": "Ne, zadrži "
      }
    }
  }
}
